module.exports = __webpack_public_path__ + "img/ch55.8b62cd1a.png";